import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        backgroundColor: '#54579C',
        height: '100%'
    },
    iconBackPage: {
        marginTop: 50
    },
    contentQrCode: {
        width: '85%',
        height: 183,
        alignSelf: 'center',
        marginTop: '5%'
    },
    textInfoQrCode: {
        fontWeight: 'bold',
        fontSize: 14,
        textAlign: 'center',
        color: '#fff',
        marginTop: -20
    },
    btnBarCode: {
        position: 'relative',
        backgroundColor: '#2C2C2E',
        width: 357,
        padding: 15,
        borderRadius: 10,
        marginTop: 40,
        alignSelf: 'center'
    },
    textBtnCode: {
        fontWeight: 'bold',
        fontSize: 14,
        textAlign: 'center',
        color: '#fff',
    }
});

export default styles;